import OutlinePostFxPipeline from './shaders/outline/OutlinePostFxPipeline.js';
export default OutlinePostFxPipeline;